export default {
  loadInitialData({ dispatch }) {
    dispatch('company/getCompanies');
    dispatch('campaign/getCampaigns');
    dispatch('channel/getChannels');
    dispatch('campaign/getReplyMessages');
    dispatch('user/getMe');
    // dispatch('user/getBrowserLocale');
    dispatch('alerts/getStaffAlerts');
    dispatch('activities/getAllActivities');
    dispatch('activities/startActivityPolling');
    dispatch('plugin/getPlugins');
    dispatch('survey/getDemographics');
    dispatch('survey/getSurveys');
  },
};



// WEBPACK FOOTER //
// ./src/store/app/actions.js